import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ThemeInverse } from '@frontend/sports/common/ui/shared';
import { SportsThemedNotificationDirective, ThemeNotificationVariant } from '@frontend/sports/common/ui/sports-themed-notifcation-bubble';
import { LinkDirective } from '@frontend/sports/common/ui/sports-themed-pills';
import { DsDivider } from '@frontend/ui/divider';
import { DsNotificationBubble } from '@frontend/ui/notification-bubble';
import { DsTab, DsTabHeader, DsTabsGroup, TabsGroupIndicatorType, TabsGroupSizesType } from '@frontend/ui/tabsgroup';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';

import { SportsThemedTabsDirective } from '../sports-themed-tabs.directive';
import { ThemeSize } from '../types';
import { SelectedTabItem, TabItemUiViewModel } from './tab-item-view.model';

@Component({
    selector: 'ms-tab-group-counter',
    imports: [
        DsNotificationBubble,
        SportsThemedNotificationDirective,
        DsDivider,
        SpeculativeLinkDirective,
        LinkDirective,
        NgTemplateOutlet,
        SportsThemedTabsDirective,
        DsTabsGroup,
        DsTab,
        DsTabHeader,
    ],
    templateUrl: './tab-group-with-counter.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TabGroupWithCounterComponent {
    @Input({ required: true }) tabs: TabItemUiViewModel[] = [];
    @Input({ required: true }) indicator: TabsGroupIndicatorType = 'underline';
    @Input({ required: true }) size: TabsGroupSizesType = 'small';
    @Input({ required: false }) themeInverseIndicator?: ThemeInverse;
    @Input({ required: false }) showBorder?: boolean;
    tabSize: ThemeSize;
    counterVariant: ThemeNotificationVariant = {
        'default': 'neutral',
        'mgm-dice': 'utility',
        'sports-interaction': 'utility',
    };

    activeCounterVariant: ThemeNotificationVariant = {
        'default': 'primary',
        'mgm-dice': 'utility',
        'sports-interaction': 'utility',
    };

    constructor() {
        this.tabSize = {
            'betboo-br': 'small',
            'sportingbet-br': 'small',
        };
    }

    get active(): TabItemUiViewModel {
        return (this.tabs && this.tabs.filter((tab) => tab.active).pop()) ?? this.tabs[0];
    }

    @Output() readonly tabSelected = new EventEmitter<SelectedTabItem>();
}
